<template>
    <div>
        <b-row>
            <b-col xl="12" lg="12" sm="12" class="mt-2">
                <div v-if="!title_hide" style="font-size:16px; background-color: #005B5B;">
                    <h5 class="text-white text-center">
                        {{ $t('externalUser.documents') }}
                    </h5>
                </div>
                <b-table  bordered :items="documents" :fields="columns" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                        {{ $n(data.index + 1 ) }}
                    </template>
                    <template v-slot:cell(image)="data">
                        <a :href="grantAllowanceServiceBaseUrl + 'storage'+ '/grant-panel' + '/' + data.item.attachment"
                            target="_blank" rel="noopener noreferrer">
                            {{ $t('globalTrans.download') }} <i class="ri-download-cloud-line" ></i>
                        </a>
                        <!-- <a :href="grantAllowanceServiceBaseUrl + 'download-attachment?file='+ path +'/' + data.item.attachment" target="_blank" v-if="data.item.attachment">
                            {{ $t('globalTrans.download') }}
                            <i class="ri-download-cloud-line" ></i>
                        </a> -->
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { grantAllowanceServiceBaseUrl } from '@/config/api_config'
export default {
    props: ['path', 'documents', 'title_hide'],
    data () {
      return {
          grantAllowanceServiceBaseUrl
      }
    },
    computed: {
        columns () {
            const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
                { label: this.$t('social_service.document_title_en'), class: 'text-left' },
                { label: this.$t('social_service.document_title_bn'), class: 'text-left' },
                { label: this.$t('externalUser.document'), class: 'text-left' }
            ]

            const keys = [
                    { key: 'index' },
                    { key: 'document_title' },
                    { key: 'document_title_bn' },
                    { key: 'image' }
                ]

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
        }
    }
}
</script>
